import { render } from "./hotels.vue?vue&type=template&id=b9df96ea&scoped=true"
import script from "./hotels.vue?vue&type=script&lang=js"
export * from "./hotels.vue?vue&type=script&lang=js"

import "./hotels.vue?vue&type=style&index=0&id=b9df96ea&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9df96ea"]])

export default __exports__